export default "__VITE_ASSET__Pa3rwd$E__"